import { Autocomplete, TextField, Chip, Box, InputAdornment } from '@mui/material';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import theme from './Theme';
import { PlaceFormData } from '@/hooks/usePlaceForm';

interface CategoryFieldsProps {
  formData: PlaceFormData;
  onChange: (name: string, value: any) => void;
}

const ageCategories = ['baby', 'child', 'teen', 'adult', 'elderly'];
const tagsList = [
  'calisthenics',
  'weightlifting',
  'aerobics',
  'yoga',
  'tennis',
  'football',
  'volleyball',
  'table tennis',
  'chess',
  'running and jogging',
  'skating and blading',
  'surfing',
  'basketball',
  'general mobility',
  'hiking and trailing',
  'racing and carting',
  'kid playground',
];

const ageCategoryLabel = (value: string) => {
  const labels: Record<string, string> = {
    baby: 'Baby (0 to 3)',
    child: 'Child (4-12)',
    teen: 'Teen (13-17)',
    adult: 'Adult (18+)',
    elderly: 'Elderly (67+)',
  };
  return labels[value] || value;
};

export const CategoryFields = ({ formData, onChange }: CategoryFieldsProps) => {
  return (
    <>
      <Autocomplete
        multiple
        options={ageCategories}
        getOptionLabel={(option) => ageCategoryLabel(option)}
        value={formData.age_category}
        onChange={(_, values) => onChange('age_category', values)}
        renderInput={(params) => (
          <TextField 
            {...params} 
            variant="outlined" 
            label="Age Category" 
            margin="normal"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <InputAdornment position="start">
                    <AccessibilityIcon sx={{ color: theme.palette.accent.main }} />
                  </InputAdornment>
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: 'primary.main' },
                '&.Mui-focused fieldset': { borderWidth: 2, borderColor: 'primary.main' },
              },
            }}
          />
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              key={index}
              label={ageCategoryLabel(option)}
              {...getTagProps({ index })}
            />
          ))
        }
      />
      <Autocomplete
        multiple
        options={tagsList}
        value={formData.tags}
        onChange={(_, values) => onChange('tags', values)}
        renderInput={(params) => (
          <TextField 
            {...params} 
            variant="outlined" 
            label="Tags" 
            margin="normal"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <InputAdornment position="start">
                    <LocalOfferIcon sx={{ color: theme.palette.accent.main }} />
                  </InputAdornment>
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: 'primary.main' },
                '&.Mui-focused fieldset': { borderWidth: 2, borderColor: 'primary.main' },
              },
            }}
          />
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip key={index} label={option} {...getTagProps({ index })} />
          ))
        }
      />
    </>
  );
};
